import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CmpsDialog, CmpsDialogRef } from '@cmps/ng-uikit';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../../../common/take-until-destroy.decorator';
import { CompensationBonusData } from '../../core/compensation-bonus-data.model';
import { ScorecardDataService } from '../../core/data.service';
import { Widget, WidgetType } from '../../core/template-definition.model';
import { TranslationKeyMap } from '../../scorecard.i18n';
import { CMPS_SCORECARD_WIDGET } from '../../scorecard.metadata';

import { ScCompBonusGridModalComponent } from './comp-bonus-grid-modal.component';

@Component({
    selector: 'cmps-scorecard-compensation-bonus-widget',
    templateUrl: './comp-bonus-widget.component.html',
})
@TakeUntilDestroy()
export class ScCompBonusWidgetComponent implements OnInit, OnDestroy {
    /** @private */ _data: CompensationBonusData;

    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _collapsed: boolean;

    /** @private */ get _isLoadingData(): Observable<boolean> {
        return this._loadingData.asObservable();
    }

    public headerColour: string;
    public headerTextColour: string;
    public backgroundColour: string;
    public textColour: string;

    private readonly _loadingData: BehaviorSubject<boolean>;
    private _dialogRef: CmpsDialogRef<ScCompBonusGridModalComponent, any>;

    constructor(
        private readonly _dataService: ScorecardDataService,
        private readonly _dialog: CmpsDialog,
        @Inject(CMPS_SCORECARD_WIDGET) /** @private */ public _widget: Widget,
    ) {
        this._loadingData = new BehaviorSubject<boolean>(false);
        this.headerColour = _widget.headerColour;
        this.headerTextColour = _widget.headerTextColour;
        this.backgroundColour = _widget.backgroundColour;
        this.textColour = _widget.textColour;
    }

    ngOnInit(): void {
        this._dataService
            .observableForWidgetType<CompensationBonusData>(
                WidgetType.COMPENSATION_BONUS,
            )
            .pipe(
                tap((data) => {
                    this._data = data;
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._dialogRef && this._dialogRef.close();
    }

    /** @private */ _onBonusDetailClick(
        event: MouseEvent | KeyboardEvent,
    ): void {
        event.stopPropagation();
        const data = this._data ? this._data.compensationBaseBonus : null;
        this._dialogRef = this._dialog.open(ScCompBonusGridModalComponent, {
            data,
        });
    }
}
